/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const ModelContextReducer = (state, action) => {
    switch (action?.type) {
        case "SET_FIELD_ITEM": {
            const { name, value } = action;
            return {
                ...state,
                [name]: value,
            };
        }
        default: {
            // Logger.debug('error');

            return {
                ...state,
            };
        }
    }
};

export default ModelContextReducer;
